// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"2e25d5d4","175":"c6385f41","189":"ac4e9c79"}[chunkId] + ".chunk.js";
};